import dayjs, { Dayjs } from "dayjs";
import { ChannelkartNetworkGet } from "../../../services/networkService";
import { OutletLedgerData, OutletLedgerResult, OutletLedgerTransaction } from "../../../types/types";
import { getOutletDetailsMap } from "../../deliveryConfirmation/DeliveryConfirmationService";


export const fetchOutletLedgerData = async () => {
try {

    const size = 500;
    let page = 0;
    let creditData: any[] = [];
    let hasMoreData = true;

    while (hasMoreData) {
        const api2Response = await ChannelkartNetworkGet(
            `/creditStatus/getCreditStatusForOutletLedger?page=${page}&size=${size}`
        );

        // Extract data from response
        const pageData = Array.isArray(api2Response?.data?.content)
            ? api2Response.data.content
            : [];

        // Append to creditData
        creditData = [...creditData, ...pageData];

        // Check if there's more data to fetch
        hasMoreData = pageData.length === size;
        page += 1;
    }
    
    // Fetch outlet details once (assuming it doesn't need pagination)
    const outletDetails = await getOutletDetailsMap();
    const result: OutletLedgerData[] = creditData.map((creditItem: any, idx: number) => {
        const outletCode = creditItem.outletCode || "";

        const outletInfo = outletDetails[outletCode] || {
            outletName: "",
            preferredPaymentMode: "",
            gstNo: false,
        };
        return {
            id: creditItem.outletCode,
            outletCode: creditItem.outletCode ?? "",
            creditAmount: creditItem.creditAmount ?? 0,
            lastBilledDate: creditItem.lastBilledDate ? dayjs(creditItem.lastBilledDate).format('DD-MM-YYYY') : "-",
            lastPaymentDate: creditItem.amountLastReceived ? dayjs(creditItem.amountLastReceived).format('DD-MM-YYYY') : "-",
            createdOn: outletInfo.creationTime ? dayjs(outletInfo.creationTime).format('DD-MM-YYYY') : "-",
            outletName: outletInfo.outletName || "-",
            redirectIcon:"eyeIcon"
        };
       
    });

    return result;
} catch (error) {
    console.error("Error in fetchAllData:", error);
    throw error;
}
};
export const fetchOutletLedgerTransactions = async (startDate: Dayjs, endDate: Dayjs) => {
        
    const loginId = JSON.parse(localStorage.authContext)?.user?.loginId;
    try {

        const size = 500;
        let page = 0;
        let transactionData: any[] = [];
        let hasMoreData = true;

        while (hasMoreData) {
            const api2Response = await ChannelkartNetworkGet(
                `/getAuditLogs?transactionName=outletledger&additionalFields=additionalFields=documentdate,particular,debitamount,creditamount&additionalFilters=userid:${loginId}&fromDate=${startDate.format('YYYY-MM-DD')}&toDate=${endDate.format('YYYY-MM-DD')}&page=${page}&size=${size}`
            );

            // Extract data from response
            const pageData = Array.isArray(api2Response?.data?.content)
                ? api2Response.data.content
                : [];

            // Append to transactionData
            transactionData = [...transactionData, ...pageData];

            // Check if there's more data to fetch
            hasMoreData = pageData.length === size;
            page += 1;
        }
        
        const result: OutletLedgerTransaction[] = transactionData.map((transaction: any, idx: number) => {
            return {
                documentDate: transaction.documentdate,
                documentId: transaction.documentdate,
                description: transaction.action,
                particular: transaction.particular,
                debitAmount: transaction.debitamount,
                creditAmount: transaction.creditamount
            };
        
        });

        return result;
    } catch (error) {
        console.error("Error in fetchAllData:", error);
        throw error;
    }
};